import { render, staticRenderFns } from "./InstanceEditBookables.vue?vue&type=template&id=1cb78982&"
import script from "./InstanceEditBookables.vue?vue&type=script&lang=js&"
export * from "./InstanceEditBookables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports